import createSharedComposable from '@nicolaudie-group/ng-ui-kit/helpers/createSharedComposable'

import useRouterStore from '@/stores/router.store'
import {
  reactive,
  computed,
  watch,
} from 'vue'

function useQueries() {
  const routerStore = useRouterStore()
  const routeQueries = computed(() => (routerStore.route.query || {}))

  const queries = reactive({})

  watch(routeQueries, (newRouteQueries) => {
    Object.map(queries, (key) => {
      if (typeof newRouteQueries[key] === 'undefined') {
        // Remove the properties that are not defined anymore in the route
        delete queries[key]
      } else {
        // And update properties that were previously defined
        queries[key] = newRouteQueries[key]
      }
    })
    // Add new properties (there may be some overlap with the update above but it's okay)
    Object.map(newRouteQueries, (key, value) => {
      queries[key] = value
    })
  }, { immediate: true })

  watch(queries, (newQueries) => {
    const changed = !Object.compare(
      newQueries,
      routeQueries.value,
      {
        depth: 1,
      },
    )

    if (changed) {
      const to = {
        ...routerStore.route,
        query: newQueries,
      }
      routerStore.replace(to)
    }
  }, { immediate: true })

  return queries
}

// Use a shared reactivity scope, so that subscribed scopes
// use the same watchers/refs
export default createSharedComposable(useQueries)
